import axios from '@/utils/axios';

export type OverlapSession = {
  sessionId?: number;
  bookingId?: number;
  startTime?: string;
  endTime?: string;
  status?: string;
  date?: string;
  time?: string;
  timeslot?: string;
};

export type ProviderConflict = {
  sessionA: OverlapSession;
  sessionB: OverlapSession;
  overlapStart: string;
  overlapEnd: string;
};

export type ProviderOverlap = {
  providerId: number;
  providerName: string;
  providerEmail?: string;
  conflicts: ProviderConflict[];
};

export type UnresolvedOverlapSession = {
  providerId?: number;
  sessionId?: number;
  reason?: string;
};

export type ProviderSessionOverlapData = {
  startDate: string;
  endDate: string;
  providersChecked: number;
  providersWithConflicts: number;
  totalConflicts: number;
  overlaps: ProviderOverlap[];
  unresolvedSessions: UnresolvedOverlapSession[];
};

export type ProviderSessionOverlapResponse = {
  data: ProviderSessionOverlapData;
  message?: string;
};

export async function fetchProviderSessionOverlaps(params: {
  startDate: string;
  endDate: string;
}): Promise<ProviderSessionOverlapData> {
  const { startDate, endDate } = params;
  const query = `?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(
    endDate
  )}`;

  const { data } = await axios.post<ProviderSessionOverlapResponse>(
    `/bookings/provider-session-overlaps${query}`,
    {}
  );

  return data.data;
}
